import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../../../icon';

function SaveButtonIcon({ glyph }) {
  return (
    <span className="ws-ui-save-button-icon">
      <Icon glyph={glyph} type="inherit" size="100%" />
    </span>
  );
}

SaveButtonIcon.propTypes = {
  glyph: PropTypes.string.isRequired,
};

export default SaveButtonIcon;
